import { styled } from 'styled-components';

export const LoadNoContainer = styled.div<{ $status?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px;
  border-radius: 2px;
  background-color: ${({ theme, $status }) =>
    $status ? '#F58720' : theme.defaultGrayBgColor};

  &:hover {
    ${({ $status, theme }) =>
      !$status && `background-color: ${theme.defaultGrayBgColor};`}
  }
`;
